import { ObjectRules, Datatype } from "@lib/types/validation"
import { email as emailValidator } from "@lib/validation/formats"
import validator from "@lib/validation/validator"
import { User } from "store/user/types"

export const rules: ObjectRules<User> = {
	id: false,
	roles: false,
	fullName: {
		required: true,
		type: Datatype.STRING
	},
	email: {
		required: true,
		type: Datatype.STRING,
		custom: {
			pattern: emailValidator
		}
	}
}

export default validator(rules)
